import { Component, Input, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';

export interface BreadcrumbItem {
  label: string;
  url?: string;
  isActive?: boolean;
}

@Component({
  selector: 'app-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss']
})
export class BreadcrumbComponent {
  @Input() breadcrumbs: BreadcrumbItem[] = [];
  @Input() hasUnsavedChanges = false;
  @Output() breadcrumbNavigation = new EventEmitter<BreadcrumbItem>();

  constructor(private router: Router) {}

  navigateTo(item: BreadcrumbItem): void {
    console.log('this.hasUnsavedChanges is  ',this.hasUnsavedChanges);

    if (item.url && !item.isActive) {
      // Check if URL is external (starts with http:// or https://)
      const isExternalUrl = item.url.startsWith('http://') || item.url.startsWith('https://');

      if (this.hasUnsavedChanges && !isExternalUrl) {
        // Emit event to parent component to handle unsaved changes (only for internal routes)
        this.breadcrumbNavigation.emit(item);
      } else {
        if (isExternalUrl) {
          // For external URLs, use window.location.href
          window.location.href = item.url;
        } else {
          // Direct navigation if no unsaved changes, preserving query params
          const currentQueryParams = this.router.routerState.snapshot.root.queryParams;
          this.router.navigate([item.url], {
            queryParams: currentQueryParams,
            queryParamsHandling: 'preserve'
          });
        }
      }
    }
  }
}
